import { createSlice } from '@reduxjs/toolkit';

const alertsSlice = createSlice({
  name: "alertsSlice",

  initialState: {
    alerts: [],
  },

  reducers: {
    addAlert(state, { payload }) {
      state.alerts.push(payload);
    },

    remAlert(state, { payload }) {
      const delId = payload;
      state.alerts = state.alerts.filter(alert => alert.id !== delId);
    }
  }
});

export default alertsSlice.reducer;

export const {
  addAlert,
  remAlert,
} = alertsSlice.actions;